export const TourGuideContent = {
    /********** 
     * Convention to be follow:
     *  - camelCase text (for eg. navbarContent)
     **********/

    /**Constants */
    durationDropdown: '',
    /**
     * Next Previous and skip buttons
     */
    buttons: {
        next: 'next_buttoncontent',
        previous: 'previous_buttoncontent',
        skip: 'skip_buttoncontent'
    },
    /** Ids */
    dropDownId: 'selectId',
    clickId: 'clickId',

    /********** Welcome Popup **********/
    welcomePopUp: {
        title: 'welcomepopup_welcomepopuptitle',
        content: 'welcomepopup_welcomepopupcontent',
        skip: 'welcomepopup_welcomepopupskip',
        start: 'welcomepopup_welcomepopupstart'
    },

    /**********  Navbar  **********/
    navbarContent: {
        dashboard: {
            title: 'dashboard_dashboardtitle',
            content: 'dashboard_dashboardcontent',
        },
        featureWf: {
            title: 'featurewf_featurewftitle',
            content: 'featurewf_featurewfcontent',
        },
        wfQueueMgr: {
            title: 'wfqueuemgr_wfqueuemgrtitle',
            content: 'wfqueuemgr_wfqueuemgrcontent',
        },
        configBuilder: {
            title: 'configbuilder_configbuildertitle',
            content: 'configbuilder_configbuildercontent'
        },
        dependentChecks: {
            title: 'dependentchecks_dependentcheckstitle',
            content: 'dependentchecks_dependentcheckscontent'
        },
        githubAction: {
            title: 'githubaction_githubactiontitle',
            content: 'githubaction_githubactioncontent'
        },
        workflow: {
            title: 'workflow_workflowtitle',
            content: 'workflow_workflowcontent',
        },
        workflowRun: {
            title: 'wfrun_wfruntitle',
            content: 'wfrun_wfruncontent'
        },
        admin: {
            title: 'admin_admintitle',
            content: 'admin_admincontent',
        },
        tools: {
            title: 'tools_toolstitle',
            content: 'tools_toolscontent',
        },
        links: {
            title: 'links_linkstitle',
            content: 'links_linkscontent'
        },
        help: {
            title: 'help_helptitle',
            content: 'help_helpcontent'
        },
        githubSync: {
            title: 'githubsync_githubsynctitle',
            content: 'githubsync_githubsynccontent'
        },
        prGrouping: {
            title: 'prgrouping_prgroupingtitle',
            content: 'prgrouping_prgroupingcontent'
        },
        jobExecutions: {
            title: 'jobexecutions_jobexecutionstitle',
            content: 'jobexecutions_jobexecutionscontent'
        }
    },
    /**********  Dashboard content  **********/
    DashboardContent: {
        /**********  KPI Dashboard tab  **********/
        kpidashboard: {
            title: 'dashboard_kpidashboardtitle',
            content: 'dashboard_kpidashboardcontent',

            card: {
                title: 'kpidashboard_cardtitle',
                content: 'kpidashboard_cardcontent',
                id: 'kpi_card',
            }
        },

        /**********  Distribution tab  **********/
        distribution: {
            title: 'dashboard_distributiontitle',
            content: 'dasboard_distributioncontent',

            wfExec: {
                title: 'wfexec_wfexecutiontitle',
                content: 'wfexec_wfexecutioncontent',
                id: 'dash-wf-0',
            },
            wfDuration: {
                title: 'wfduration_wfdurationtitle',
                content: 'wfduration_wfdurationcontent',
                id: 'dash-distribution-dropdown'
            },
            wfSuccess: {
                title: 'wfsuccess_wfsuccesstitle',
                content: 'wfsuccess_wfsuccesscontent',
                id: 'dash-wf-1'
            },
            wfFailed: {
                title: 'wffailed_wffailedtitle',
                content: 'wffailed_wffailedcontent',
                id: 'dash-wf-2'
            },
            wfQueued: {
                title: 'wfqueued_wfqueuedtitle',
                content: 'wfqueued_wfqueuedcontent',
                id: 'dash-wf-3'
            },
            wfInProg: {
                title: 'wfinprog_wfinprogtitle',
                content: 'wfinprog_wfinprogcontent',
                id: 'dash-wf-4'
            },
            wfAborted: {
                title: 'wfbborted_wfabortedtitle',
                content: 'wfaborted_wfabortedcontent',
                id: 'dash-wf-5'
            },
            wfStatusDist: {
                title: 'wfstatusdist_wfstatusdisttitle',
                content: 'wfstatusdist_wfstatusdistcontent',
                id: 'dash-wfStatusDistribution'
            }
        },

        /**********  Summary tab  **********/
        summary: {
            summaryDropDown: {
                title: 'summary_summary_dropdowntitle',
                content: 'summary_summary_dropdowncontent',
                id: 'wfQueDropdowns'
            },
            summaryChart: {
                title: 'summary_summary_charttitle',
                content: 'summary_summary_chartcontent',
                id: 'summary_chart'
            }
        },

        /**********  Licenses tab  **********/
        licenses: {
            mostUsedWfTable: {
                title: 'mostusedwftable_mostusedwftabletitle',
                content: 'mostusedwftable_mostusedwftablecontent',
                id: 'dash-lic-wf-content'
            },
            refresh: {
                title: 'refresh_refreshtitle',
                content: 'refresh_refreshcontent',
                id: 'dash-lic-refresh'
            },
            licStatusTable: {
                title: 'licstatustable_licstatustabletitle',
                content: 'licstatustable_licstatustablecontent',
                id: 'dash-lic-content'
            },
            utilization: {
                title: 'utilization_utilizationtitle',
                content: 'utilization_utilizationcontent',
                id: 'dash-lic-utilization'
            }
        },
        /**********  Error Diagnostics content  **********/

        errorDiagnostics: {
            errorDiagnosticsbargraphData: {
                title: 'errordiagnosticsbargraphdata_errordiagnosticsbargraphdatatitle',
                content: 'errordiagnosticsbargraphdata_errordiagnosticsbargraphdatacontent',
                id: 'weeklyErrors'
            },
            errorDiagnosticsLinechartData: {
                title: 'errordiagnosticslinechartdata_errordiagnosticslinechartdatatitle',
                content: 'errordiagnosticslinechartdata_errordiagnosticslinechartdatacontent',
                id: 'errorTrends'
            },
            errorDiagnosticstableData: {
                title: 'errordiagnosticstabledata_errordiagnosticstabledatatitle',
                content: 'errordiagnosticstabledata_errordiagnosticstabledatacontent',
                id: 'tableData'
            },
        },
    },


    /**********  Feature workflow content  **********/
    featureWfContent: {
        charts: {
            dropdowns: {
                title: 'dropdowns_dropdown-optiontitle',
                content: 'dropdowns_dropdown-optioncontent',
                id: 'wf-configWf',
            },
            deploymentFreq: {
                title: 'deploymentfreq_deployment-frequencytitle',
                content: 'deploymentfreq_deployment-frequencycontent',
                id: 'wf-configWf'
            },
            changeFailRate: {
                title: 'changefailrate_change_failure_ratetitle',
                content: 'changefailrate_change_failure_ratecontent',
                id: 'wf-fail'
            },
            avgLeadTime: {
                title: 'avgleadtime_avgleadtimetitle',
                content: 'avgleadtime_avgleadtimecontent',
                id: 'wf-avgLead'
            },
            avgRestoreTime: {
                title: 'avgrestoretime_avgrestoretimetitle',
                content: 'avgrestoretime_avgrestoretimecontent',
                id: 'wf-avgRestore'
            }
        },
        featureWfTable: {
            wfDetail: {
                title: 'wfdetail_wfdetailtitle',
                content: 'wfdetail_wfdetailcontent',
                id: 'wf-featureId'
            },
            wfTableExpand: {
                title: 'wftableexpand_wftableexpandtitle',
                content: 'wftableexpand_wftableexpandcontent',
                id: 'wf-expand'
            },
            qualityGate_sum: {
                title: 'qualitygate_sum_qualitygate_sumtitle',
                content: 'qualitygate_sum_qualitygate_sumcontent',
                id: 'wf-qualityGates'
            }
        }
    },

    /**********  Workflow queue manager  **********/
    wfQueueMgr: {
        liveUpd: {
            title: 'liveupd_liveupdtitle',
            content: 'liveupd_liveupdcontent',
            id: 'que-queLiveUpdateId'
        },
        dropDown: {
            title: 'dropdown_dropdowntitle',
            content: 'dropdown_dropdowncontent',
            id: 'wfQueDropdowns'
        },
        charts: {
            waitLic: {
                title: 'charts_chartswaitlictitle',
                content: 'charts_chartswaitliccontent',
                id: 'que-waitLicense'
            },
            waitDep: {
                title: 'charts_chartswaitdeptitle',
                content: 'charts_chartswaitdepcontent',
                id: 'que-waitDependency'
            },
            waitAgent: {
                title: 'charts_chartswaitagenttitle',
                content: 'charts_chartswaitagentcontent',
                id: 'que-waitAgent'
            },
            runningWf: {
                title: 'charts_chartsrunningwftitle',
                content: 'charts_chartsrunningwfcontent',
                id: 'que-running'
            }
        },
        wfQueTable: {
            wfQueueDetail: {
                title: 'wfquetable_wfquedetailtitle',
                content: 'wfquetable_wfquedetailcontent',
                id: 'que-wfQueDetailId'
            },
            wfQueueTable: {
                title: 'wfquetable_wfqueuetabletitle',
                content: 'wfquetable_wfqueuetablecontent',
                id: 'que-wfQueTableId'
            },
            priority: {
                title: 'wfquetable_wfquetableprioritytitle',
                content: 'wfquetable_wfquetableprioritycontent',
                id: 'que-priorityId'
            },
            action: {
                title: 'wfquetable_wfquetableactiontitle',
                content: 'wfquetable_wfquetableactioncontent',
                id: 'que-actionId'
            },
            wfTableExpand: {
                title: 'wfquetable_wfquetablewftableexpandtitle',
                content: 'wfquetable_wfquetablewftableexpandcontent',
                id: 'wf-expand'
            }
        }
    },

    /**********  Configuration builder **********/
    configBuilder: {
        /**Config builder page */
        workflow: {
            btn: {
                title: 'workflow_workflowbtntitle',
                content: 'workflow_workflowbtncontent',
                id: 'addConfigId'
            },
            addConfigName: {
                title: 'workflow_workflowaddconfignametitle',
                content: 'workflow_workflowaddconfignamecontent',
                id: 'config-addConfigName'
            },
            selectConfig: {
                title: 'workflow_workflowselectconfigtitle',
                content: 'workflow_workflowselectconfigcontent',
                id: 'config-wfSelect'
            },
            wfDetailsTab: {
                title: 'workflow_workflowwfdetailstabtitle',
                content: 'workflow_workflowwfdetailstabcontent',
                id: 'wf-detailsTabId'
            },
            tabContainer: {
                title: 'workflow_workflowtabcontainertitle',
                content: 'workflow_workflowtabcontainercontent'
            },
            runnerDetailEdit: {
                title: 'workflow_workflowrunnerdetailedittitle',
                content: 'workflow_workflowrunnerdetaileditcontent',
                id: 'config-runnerId'
            },
            runnerDetail: {
                title: 'workflow_workflowrunnerdetailtitle',
                content: 'workflow_workflowrunnerdetailcontent',
                id: 'config-editRunner'
            },
            toolsThreshHoldTab: {
                table: {
                    title: 'workflow_workflowtoolsthreshholdtabtabletitle',
                    content: 'workflow_workflowtoolsthreshholdtabtablecontent',
                    id: 'config-threshTableId'
                },
                checkBox: {
                    title: 'workflow_workflowtoolsthreshholdtabcheckboxtitle',
                    content: 'workflow_workflowtoolsthreshholdtabcheckboxcontent',
                    id: 'config-checkboxId'
                },
                inputBox: {
                    title: 'workflow_workflowtoolsthreshholdtabinputboxtitle',
                    content: 'workflow_workflowtoolsthreshholdtabinputboxcontent',
                    id: 'config-thresholdId'
                },
                condition: {
                    title: 'workflow_workflowtoolsthreshholdtabconditiontitle',
                    content: 'workflow_workflowtoolsthreshholdtabconditioncontent',
                    id: 'config-conditionId'
                },
                allFail: {
                    title: 'workflow_workflowtoolsthreshholdtaballfailtitle',
                    content: 'workflow_workflowtoolsthreshholdtaballfailcontent',
                    id: 'config-allowFailId'
                }
            },
            saveBtn: {
                title: 'workflow_workflowsavebtntitle',
                content: 'workflow_workflowsavebtncontent',
                id: 'config-saveBtnId'
            },
            configTable: {
                title: "workflow_workflowconfigtabletitle",
                content: 'workflow_workflowconfigtablecontent',
                id: 'config-table'
            },
            configTableEdit: {
                title: "workflow_workflowconfigtableedittitle",
                content: "workflow_workflowconfigtableeditcontent",
                id: 'config-tableEdit'
            },
            configTableDelete: {
                title: "workflow_workflowconfigtabledeletetitle",
                content: "workflow_workflowconfigtabledeletecontent",
                id: 'config-confgDelete'
            }
        },
        /**Integrated workflow page */
        integratedWf: {

        },
    },

    /**********  Workflows **********/
    workflows: {
        /**********  Workflow page  **********/
        wf: {
            WfDeploymentFrequency: {
                title: 'wf_wfdeploymentfrequencytitle',
                content: 'wf_wfdeploymentfrequencycontent',
                id: 'wf-frequenc'
            },
            wfSearch: {
                title: 'wf_wfsearchtitle',
                content: 'wf_wfsearchcontent',
                id: 'wf-search'
            },
            wfTable: {
                title: 'wf_wftabletitle',
                content: 'wf_wftablecontent',
                id: 'wf-table'
            },
            wfTypeManual: {
                title: 'wf_wftypemanualtitle',
                content: 'wf_wftypemanualcontent',
                id: 'wf-type-manual'
            },
            wfPerformance: {
                title: 'wf_wfperformancetitle',
                content: 'wf_wfperformancecontent',
                id: 'wf-performance'
            },
            wfView: {
                title: 'wf_wfviewtitle',
                content: 'wf_wfviewcontent',
                id: 'wf-view'
            }
        },
        /**********  Workflow run page  **********/
        wfrun: {
            wfRunTable: {
                title: 'wfrun',
                content: 'wfrun',
                id: 'wf-run'
            },
            wfRunDropdowns: {
                title: 'wfrun_wfrundropdownstitle',
                content: 'wfrun_wfrundropdownscontent',
                id: 'wfRunDropdowns'
            },
            wfRunSearch: {
                title: 'wfrun_wfsearchtitle',
                content: 'wfrun_wfsearchcontent',
                id: 'wf-search'
            },
            wfRunCard: {
                title: 'wfrun_wfruncardtitle',
                content: 'wfrun_wfruncardcontent',
                id: 'wfRunCard'
            },
            wfRunCardMenu: {
                title: 'wfrun_wfruncardmenutitle',
                content: 'wfrun_wfruncardmenucontent',
                id: 'wfRunCardMenu'
            },
            wfExpand: {
                title: 'wfrun_wfexpandtitle',
                content: 'wfrun_wfexpandcontent',
                id: 'wf-expand'
            },
            wfExpanded: {
                id: 'wf-expanded'
            },
            wfRunOverview: {
                title: 'wfrun_wfrunoverviewtitle',
                content: 'wfrun_wfrunoverviewcontent',
                id: 'wf-runoverview'
            },
            wfQualityGates: {
                title: 'wfrun_wfqualitygatestitle',
                content: 'wfrun_wfqualitygatescontent',
                id: 'wf-qualityGates'
            },
            wfInputArgs: {
                title: 'wfrun_wfinputargstitle',
                content: 'wfrun_wfinputargscontent',
                id: 'wfRun-inputArgs'
            },
            wfCardMenu: {
                title: 'wfrun_wfcardmenutitle',
                content: 'wfrun_wfcardmenucontent',
                id: 'wf-cardmenu'
            },
            wfBack: {
                title: 'wfrun_wfbacktitle',
                content: 'wfrun_wfbackcontent',
                id: 'wf-back'
            }

        }
    },

    /**********  Admin tab content  **********/
    adminContent: {
        /**********  Access page content  **********/
        access: {
            access_table: {
                title: 'access_table_access_tabletitle',
                content: 'access_table_access_tablecontent',
                id: 'access_table'
            },
            removeAssignGrp: {
                title: 'removeassigngrp_removeassigngrptitle',
                content: 'removeassigngrp_removeassigngrpcontent',
                id: 'acc_table_grps_td'
            },
            grpColumnValue: {
                title: 'grpcolumnvalue_grpcolumnvaluetitle',
                content: 'grpcolumnvalue_grpcolumnvaluecontent',
                id: 'acc_table_grps_td'
            },
            addValueAssignGrp: {
                title: 'addvalueassigngrp_addvalueassigngrptitle',
                content: 'addvalueassigngrp_addvalueassigngrpcontent',
                id: 'acc_table_add_grp'
            },
            removeGrpSaveData: {
                title: 'removegrpsavedata_removegrpsavedatatitle',
                content: 'removegrpsavedata_removegrpsavedatacontent',
                id: 'acc_table_save_btn'
            },
            assignGrpSaveData: {
                title: 'assigngrpsavedata_assigngrpsavedatatitle',
                content: 'assigngrpsavedata_assigngrpsavedatacontent',
                id: 'acc_table_save_btn'
            }
        },
        /**********  Tools page content  **********/
        tools: {
            toolsTable: {
                title: 'tools_toolstabletitle',
                content: 'tools_toolstablecontent',
                id: 'table-head'
            },
            refresh: {
                title: 'tools_toolsrefreshtitle',
                content: 'tools_toolsrefreshcontent',
                id: 'tool-refresh'
            },
            addTool: {
                title: 'tools_toolsaddtooltitle',
                content: 'tools_toolsaddtoolcontent',
                id: 'add-Tool'
            },
            primaryInfo: {
                title: 'tools_toolsprimaryinfotitle',
                content: 'tools_toolsprimaryinfocontent',
                id: 'primaryInfoFields'
            },
            resourceLimit: {
                title: 'tools_toolsresourcelimittitle',
                content: 'tools_toolsresourcelimitcontent',
                id: 'resourceLimit'
            },
            toggleBtn: {
                title: 'tools_toolstogglebtntitle',
                content: 'tools_toolstogglebtncontent',
                id: 'toggle-Btn'
            },
            qualityGates: {
                title: 'tools_toolsqualitygatestitle',
                content: 'tools_toolsqualitygatescontent',
                id: 'qualityGates'
            },
            qgExpand: {
                title: 'tools_toolsqgexpandtitle',
                content: 'tools_toolsqgexpandcontent',
                id: 'expand'
            },
            clickExpand: {
                id: 'clickExpand'
            },
            qualityGatesTbl: {
                title: 'tools_toolsqualitygatestbltitle',
                content: 'tools_toolsqualitygatestblcontent',
                id: 'qualityGatesTbl'
            },
            saveBtn: {
                title: 'tools_toolssavebtntitle',
                content: 'tools_toolssavebtncontent',
                id: 'saveBtn',
            },
            cancelBtn: {
                id: 'cancelBtn'
            },
            qgFields: {
                title: 'tools_toolsqgfieldstitle',
                content: 'tools_toolsqgfieldscontent',
                id: 'qualityGatesFields',
            },
            modalSaveBtn: {
                title: 'tools_toolsmodalsavebtntitle',
                content: 'tools_toolsmodalsavebtncontent',
                id: 'modalSaveBtn'
            },
            editBtn: {
                title: 'tools_toolseditbtntitle',
                content: 'tools_toolseditbtncontent',
                id: 'edit-ToolBtn'
            },
            deleteBtn: {
                title: 'tools_toolsdeletebtntitle',
                content: 'tools_toolsdeletebtncontent',
                id: 'delete-ToolBtn'
            },
        }
    },

    /********** Links page content **********/
    linksPage: {
        linksCancelClick: {
            id: 'linkscancelclick'
        },
        linksAdd: {
            title: 'linkspage_linksaddtitle',
            content: 'linkspage_linksaddcontent',
            id: 'linksadd',
            linksAddBlock: {
                title: 'linkspage_linksaddblocktitle',
                content: 'linkspage_linksaddblockcontent',
                id: 'linksaddblock'
            },
            linksAddStatus: {
                title: 'linkspage_linksstatustitle',
                content: 'linkspage_linksstatuscontent',
                id: 'linksstatus'
            },
            linksAddSave: {
                title: 'linkspage_linkssavetitle',
                content: 'linkspage_linkssavecontent',
                id: 'linkssave'
            }
        },
        linksSearch: {
            title: 'linkspage_linkssearchtitle',
            content: 'linkspage_linkssearchcontent',
            id: 'linkssearch'
        },
        linksTable: {
            linksTableInfo: {
                title: 'linkspage_linkstableinfotitle',
                content: 'linkspage_linkstableinfocontent',
                id: 'linkstableinfo'
            },
            linksTableEdit: {
                title: 'linkspage_linkstableedittitle',
                content: 'linkspage_linkstableeditcontent',
                id: 'linkstableedit'
            },
            linksTableDelete: {
                title: 'linkspage_linkstabledeletetitle',
                content: 'linkspage_linkstabledeletecontent',
                id: 'linkstabledelete'
            }
        }
    },

    /**********  Help page content  **********/
    helpPage: {
        pages: {
            title: 'helppage_helppagepagestitle',
            content: 'helppage_helppagepagescontent',
            id: 'Pages'
        },
        search: {
            title: 'helppage_searchtitle',
            content: 'helppage_searchcontent',
            id: 'search'
        },
        documents: {
            title: 'helppage_helppagedocumentstitle',
            content: 'helppage_helppagedocumentscontent',
            id: 'documents'
        },
        viewMore: {
            title: 'helppage_viewmoretitle',
            content: 'helppage_viewmorecontent',
            id: 'viewMore'
        },
    },

    /**********  Configuration builder **********/
    githubAction: {
        /**Config builder page */
        table: {
            title: 'gitaction_gitactiontabletitle',
            content: 'gitaction_gitactionTablecontent',
            id: 'gitactionTable'
        },
        tableContent: {
            status: {
                title: 'gitaction_gitactiontablestatustitle',
                content: 'gitaction_gitactiontablestatuscontent',
                id: 'gitactionStatus'
            },
            runWf: {
                title: 'gitaction_gitactionrunwftitle',
                content: 'gitaction_gitactionrunwfcontent',
                id: 'gitActionRunWf'
            }
        },
        expand: {
            title: 'gitaction_gitactionexpandedtitle',
            content: 'gitaction_gitactionexpandedcontent',
            run: {
                title: 'gitaction_gitactionrunwftitle',
                content: 'gitaction_gitactionexecutewfcontent',
                id: 'runManualWf'
            }
        }
    },

    /**********  Dependent Checks **********/
    dependentChecks: {
        // First: Saved table and existing configurations
        configTable: {
            title: 'dependentchecks_configtabletitle',
            content: 'dependentchecks_configtablecontent',
            selector: '[data-tour="dep-configTable"]'
        },
        expandBtn: {
            title: 'dependentchecks_expandbtntitle',
            content: 'dependentchecks_expandbtncontent',
            selector: '[data-tour="dep-expand"]'
        },
        statusToggle: {
            title: 'dependentchecks_statustoggletitle',
            content: 'dependentchecks_statustogglecontent',
            selector: '[data-tour="dep-status"]'
        },
        editBtn: {
            title: 'dependentchecks_editbtntitle',
            content: 'dependentchecks_editbtncontent',
            selector: '[data-tour="dep-edit"]'
        },
        deleteBtn: {
            title: 'dependentchecks_deletebtntitle',
            content: 'dependentchecks_deletebtncontent',
            selector: '[data-tour="dep-delete"]'
        },
        
        // Then: Add new configuration page
        addBtn: {
            title: 'dependentchecks_addbtntitle',
            content: 'dependentchecks_addbtncontent',
            selector: '[data-tour="dep-add"]'
        },
        configName: {
            title: 'dependentchecks_confignametitle',
            content: 'dependentchecks_confignamecontent',
            selector: '[data-tour="dep-configName"]'
        },
        orgField: {
            title: 'dependentchecks_orgtitle',
            content: 'dependentchecks_orgcontent',
            selector: '[data-tour="dep-org"]'
        },
        repoPattern: {
            title: 'dependentchecks_repopatterntitle',
            content: 'dependentchecks_repopatterncontent',
            selector: '[data-tour="dep-repoPattern"]'
        },
        branchField: {
            title: 'dependentchecks_branchtitle',
            content: 'dependentchecks_branchcontent',
            selector: '[data-tour="dep-branch"]'
        },
        eventDropdown: {
            title: 'dependentchecks_eventdropdowntitle',
            content: 'dependentchecks_eventdropdowncontent',
            selector: '[data-tour="dep-event"]'
        },
        actionDropdown: {
            title: 'dependentchecks_actiondropdowntitle',
            content: 'dependentchecks_actiondropdowncontent',
            selector: '[data-tour="dep-action"]'
        },
        configurationsCard: {
            title: 'dependentchecks_configurationscardtitle',
            content: 'dependentchecks_configurationscardcontent',
            selector: '[data-tour="dep-configurationsCard"]'
        },
        dependencyGraph: {
            title: 'dependentchecks_dependencygraphtitle',
            content: 'dependentchecks_dependencygraphcontent',
            selector: '[data-tour="dep-dependencyGraph"]'
        },
        cancelBtn: {
            title: 'dependentchecks_cancelbtntitle',
            content: 'dependentchecks_cancelbtncontent',
            selector: '[data-tour="dep-cancel"]'
        },
        saveBtn: {
            title: 'dependentchecks_savebtntitle',
            content: 'dependentchecks_savebtncontent',
            selector: '[data-tour="dep-save"]'
        }
    },

    /**********  GitHub Sync **********/
    githubSync: {
        orgDropdown: {
            title: 'githubsync_orgdropdowntitle',
            content: 'githubsync_orgdropdowncontent',
            id: 'githubsync-org'
        },
        repoDropdown: {
            title: 'githubsync_repodropdowntitle',
            content: 'githubsync_repodropdowncontent',
            id: 'githubsync-repo'
        },
        branchDropdown: {
            title: 'githubsync_branchdropdowntitle',
            content: 'githubsync_branchdropdowncontent',
            id: 'githubsync-branch'
        },
        issueTemplateTab: {
            title: 'githubsync_issuetemplatetabtitle',
            content: 'githubsync_issuetemplatetabcontent',
            id: 'githubsync-issuetab'
        },
        table: {
            title: 'githubsync_tabletitle',
            content: 'githubsync_tablecontent',
            id: 'githubsync-table'
        },
        checkboxSelection: {
            title: 'githubsync_checkboxselectiontitle',
            content: 'githubsync_checkboxselectioncontent',
            selector: '#githubsync-table mat-checkbox'
        },
        syncButton: {
            title: 'githubsync_syncbuttontitle',
            content: 'githubsync_syncbuttoncontent',
            id: 'githubsync-syncbtn'
        }
    },

    /**********  PR Grouping **********/
    prGrouping: {
        topicField: {
            title: 'prgrouping_topicfieldtitle',
            content: 'prgrouping_topicfieldcontent',
            selector: '[data-tour="prg-topic"]'
        },
        repoField: {
            title: 'prgrouping_repofieldtitle',
            content: 'prgrouping_repofieldcontent',
            selector: '[data-tour="prg-repo"]'
        },
        prUrlField: {
            title: 'prgrouping_prurlfieldtitle',
            content: 'prgrouping_prurlfieldcontent',
            selector: '[data-tour="prg-prUrl"]'
        },
        dateRange: {
            title: 'prgrouping_daterangetitle',
            content: 'prgrouping_daterangecontent',
            selector: '[data-tour="prg-dateRange"]'
        },
        searchBtn: {
            title: 'prgrouping_searchbtntitle',
            content: 'prgrouping_searchbtncontent',
            selector: '[data-tour="prg-form"]'
        },
        searchBtnOnly: {
            title: 'prgrouping_searchbtnonlytitle',
            content: 'prgrouping_searchbtnonlycontent',
            selector: '[data-tour="prg-search"]'
        },
        editBtn: {
            title: 'prgrouping_editbtntitle',
            content: 'prgrouping_editbtncontent',
            selector: '[data-tour="prg-edit"]'
        },
        resultsTable: {
            title: 'prgrouping_resultstabletitle',
            content: 'prgrouping_resultstablecontent',
            selector: '[data-tour="prg-table"]'
        }
    },

    /**********  Job Executions (Scheduler) **********/
    jobExecutions: {
        datePicker: {
            title: 'jobexecutions_datepickertitle',
            content: 'jobexecutions_datepickercontent',
            selector: '[data-tour="je-date"]'
        },
        refresh: {
            title: 'jobexecutions_refreshtitle',
            content: 'jobexecutions_refreshcontent',
            selector: '[data-tour="je-refresh"]'
        },
        table: {
            title: 'jobexecutions_tabletitle',
            content: 'jobexecutions_tablecontent',
            selector: '[data-tour="je-table"]'
        },
        cancel: {
            title: 'jobexecutions_canceltitle',
            content: 'jobexecutions_cancelcontent',
            selector: '[data-tour="je-cancel"]'
        },
        builds: {
            title: 'jobexecutions_buildstitle',
            content: 'jobexecutions_buildscontent',
            selector: '[data-tour="je-builds"]'
        },
        workflows: {
            title: 'jobexecutions_workflowstitle',
            content: 'jobexecutions_workflowscontent',
            selector: '[data-tour="je-workflows"]'
        }
    }
}